var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_c('span',{staticClass:"btn-loader",class:{'loading': _vm.loading, 'inline': _vm.inline}},[_c('spinner',{staticClass:"btn-loader-spinner"}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }